import React from 'react';
import { Search, MapPin } from 'lucide-react';
import { useLanguage } from '../../lib/i18n';
interface HeroSectionProps {
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
}
export function HeroSection({
  searchQuery = '',
  onSearchChange
}: HeroSectionProps) {
  const {
    t
  } = useLanguage();
  return <div className="relative overflow-hidden bg-[#0B0B0B] text-white pt-28 pb-36 px-4 sm:px-6 lg:px-8" data-id="element-2133">
      {/* Background image — visible and vibrant */}
      <img src="https://cdn.magicpatterns.com/uploads/1UWX3upNAeRHGAGLj3nnFR/WhatsApp_Image_2026-03-20_at_13.12.53.jpg" alt="Los Santos" className="absolute inset-0 w-full h-full object-cover" data-id="element-2134" />

      {/* Layered overlays — image stays visible, text stays readable */}
      {/* Bottom-heavy gradient: dark at bottom for search bar, transparent at top for image */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-[#0B0B0B]/60 to-transparent" data-id="element-2135" />
      {/* Top vignette for headline readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0B]/50 via-transparent to-transparent" data-id="element-2136" />
      {/* Center radial for text contrast without killing the image */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 50%, rgba(11,11,11,0.55) 0%, transparent 70%)'
    }} data-id="element-2137" />

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-2138">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight mb-6 leading-tight" data-id="element-2139">
          <span className="text-white" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.5)'
        }} data-id="element-2140">
            {t('hero_title1')}
          </span>
          <br data-id="element-2141" />
          <span className="text-[#C9A34E]" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.5)'
        }} data-id="element-2142">
            {t('hero_title2')}
          </span>
        </h1>
        <p className="text-lg sm:text-xl text-white/80 mb-10 max-w-2xl mx-auto font-medium" style={{
        textShadow: '0 1px 10px rgba(0,0,0,0.5)'
      }} data-id="element-2143">
          {t('hero_subtitle')}
        </p>

        {/* Search Bar */}
        <div className="max-w-2xl mx-auto relative group" data-id="element-2144">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-2145">
            <Search className="w-5 h-5 text-white/40 group-focus-within:text-[#C9A34E] transition-colors" data-id="element-2146" />
          </div>
          <input type="text" value={searchQuery} onChange={e => onSearchChange?.(e.target.value)} placeholder={t('search_placeholder')} className="w-full bg-[#141414]/80 backdrop-blur-md border border-white/10 text-white placeholder-white/40 rounded-2xl py-4 pl-12 pr-4 focus:outline-none focus:ring-2 focus:ring-[#C9A34E]/50 focus:border-[#C9A34E] transition-all shadow-2xl" data-id="element-2147" />
        </div>
      </div>
    </div>;
}